import { toast } from 'react-toastify';
import AxiosInstance from '../../utils/AxiosInstance.jsx';
import { RecaptchaProvider } from '../../components/provider/RecaptchaProvider.jsx';
import RecaptchaV3 from '../../components/GoogleRecaptcha-v3.jsx';
import { Link } from 'react-router';
import React, { useState } from 'react';
import logo from '../../assets/logo_ys.png';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import BPassword from '../../components/ui/form/BPassword';
import { BInput } from '../../components/ui/form';
import { BAlert, BButton } from '../../components/ui/generic';
import { requiredField } from '../../utils';

const PasswordRecovery = () => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();
  const handlePasswordRecoveryForm = async (data) => {
    setError('');
    setSuccess('');
    if (!data?.email) {
      setError('Merci de saisir une adresse email valide');
      return;
    }
    await axios
      .post(`${import.meta.env.VITE_API_BASE_URL}/internal_api/password-recovery/create`, data)
      .then((callback) => {
        if (callback?.data?.error) {
          setError(callback?.data?.message);
        } else {
          setSuccess(callback?.data?.message);
        }
      });
  };

  return (
    <div
      className={`bg-primary-900 to-primary-900 font-poppins flex min-h-screen w-full flex-col items-center justify-center gap-8 bg-gradient-to-l from-purple-900 px-8 text-slate-700 lg:flex-row lg:px-24`}
    >
      <div className={'flex w-full flex-col items-center gap-4 text-white'}>
        <img src={logo} alt="Logo" className={'w-fit'} />
        <div className={'flex flex-col gap-4'}>
          <p className={'text-2xl font-medium lg:text-8xl'}>Mon espace candidat</p>
          <p className={'font-medium lg:text-4xl'}>Bienvenue sur votre portail</p>
        </div>
      </div>
      <div className={`flex w-full max-w-md items-center justify-center rounded bg-white p-4 shadow`}>
        <RecaptchaProvider>
          <form onSubmit={handleSubmit(handlePasswordRecoveryForm)} className={'flex w-full flex-col gap-2 px-6'}>
            <p className={'text-lg font-medium'}>Veuillez saisir votre adresse email</p>
            <BInput
              type={'email'}
              name={'email'}
              label={'Email'}
              placeholder="Email"
              {...register('email', {
                required: { value: true, message: requiredField },
              })}
            />
            <input
              hidden
              defaultValue={`${import.meta.env.VITE_APP_URL}/definition-mot-de-passe`}
              {...register('callback_url')}
            />
            {errors.email && <p className={'text-sm text-red-600'}>{errors.email.message}</p>}
            <RecaptchaV3 setValue={setValue} />
            <div>
              <BButton isDisabled={isSubmitting} isProcessing={isSubmitting} type={'submit'} label={'Envoyer'} />
            </div>

            {error && <BAlert color={'error'}>{error}</BAlert>}
            {success && <BAlert color={'success'}>{success}</BAlert>}

            <p className={`text-sm text-gray-400`}>
              Retourner vers la page de{' '}
              <Link className={`text-blue-500`} to={`/login`}>
                connexion
              </Link>
            </p>
          </form>
        </RecaptchaProvider>
      </div>
    </div>
  );
};

export default PasswordRecovery;
